module.exports = __webpack_public_path__ + "img/logo-black.a9f6869f.png";